import { plainToClass } from "class-transformer";
import { ExpertiseArea } from "./expertise.dictionary";
import { UserExperience } from "./expertise.objects";


export class ExpertisePage {

    constructor(userData: any) {
        $(() => {

            this.createUI();

            let existingExpertise: UserExperience = plainToClass(UserExperience, <UserExperience>userData);

            existingExpertise.setupUI();
        });
    }

    createUI(): void {
        let questionCategories: string[] = ExpertiseArea.GetExpertiseQuestionCategories();
        let areas: ExpertiseArea[] = ExpertiseArea.GetExpertiseAreas();

        let questionSwitchTemplate: HTMLTemplateElement = document.getElementById('expertise-switch-option-template') as HTMLTemplateElement;
        let questionTextTemplate: HTMLTemplateElement = document.getElementById('expertise-text-option-template') as HTMLTemplateElement;

        questionCategories.forEach((category: string) => {
            const questionColContainerOne = document.getElementById('questions-' + category + '-1');
            const questionColContainerTwo = document.getElementById('questions-' + category + '-2');
            questionColContainerOne.innerHTML = '';
            questionColContainerTwo.innerHTML = '';

            let questions: ExpertiseArea[] = areas.filter((q: ExpertiseArea) => q.category == category);
            let midPoint = Math.ceil(questions.length / 2) - 1;
            for (let i = 0; i < questions.length; i++) {
                let q = questions[i];
                let questionColContainer = questionColContainerOne;
                if (i > midPoint) {
                    questionColContainer = questionColContainerTwo;
                }
                const questionInstance = document.importNode(questionSwitchTemplate.content, true);
                questionInstance.querySelector('.custom-control-input').id = q.id;
                questionInstance.querySelector('.custom-control-label').setAttribute("for", q.id);
                questionInstance.querySelector('.custom-control-label').innerHTML = q.value;
                questionColContainer.appendChild(questionInstance);
            }
        });

        this.initializeDropdowns();
    }

    updateExpertise(): void {
        let updateData: UserExperience = new UserExperience();
        updateData.initialize();

        var actionUrl = $("#expertise-form").attr('action');

        var formData = $("#expertise-form").serializeArray();
        formData.push({ name: "payload", value: JSON.stringify(updateData) });

        $.ajax({
            url: actionUrl,
            dataType: 'JSON',
            method: 'POST',
            data: formData,
            success: (data) => { }
        });

        $("#success-modal").modal("show");

        $("html, body").animate({
            scrollTop: 0
        }, 600);

    }

    initializeDropdowns(): void {
        let questionCategories: string[] = ExpertiseArea.GetExpertiseQuestionCategories();
        let fields: ExpertiseArea[] = ExpertiseArea.GetExpertiseAreas();
        questionCategories.forEach(category => {
            $(`#select-${category}`).on("changed.bs.select", () => {
                let currentVal = $(`#select-${category}`).val();
                if (currentVal == "Yes") {
                    $(`#questions-${category}`).removeClass("d-none");
                }
                else {
                    $(`#questions-${category}`).addClass("d-none");
                    let areaFields = fields.filter(field => field.category == category);
                    areaFields.forEach(field => {
                        $("#" + field.id).prop("checked", false);
                    })
                }
            })
        })
    }
}